export default {
  logout: {
    id: 'header_bo_logout',
    defaultMessage: 'Logout',
  },
  fileLibrary: {
    id: 'header_bo_file_library',
    defaultMessage: 'File library',
  },
  avatarIcon: {
    id: 'header_bo_avatar_icon',
    defaultMessage: 'RevAvatar Icon',
  },
  profile: {
    id: 'header_bo_merchant_profile',
    defaultMessage: 'My profile',
  },
}
